const sortByUpdatedDate = (a, b) => {
  const aLastUpdated = a.metadata && +a.metadata.updatedDate;
  const bLastUpdated = b.metadata && +b.metadata.updatedDate;

  if (aLastUpdated === bLastUpdated) return 0;
  if (aLastUpdated > bLastUpdated) return -1;
  return 1;
};

export default sortByUpdatedDate;